import React, { useRef } from 'react';
import './Reviews.css';
import { FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import review1 from './review1.png';
import review2 from './review2.png';
import review3 from './review3.png';
import review4 from './review4.png';
import review5 from './review5.png';

const Reviews = () => {
  // Neue realistische Reviews mit Bildern
  const reviewsData = [
    {
      username: "✅Verified Purchase",
      image: review1,
      date: "25.05.2025",
    },
    {
      username: "✅Verified Purchase",
      image: review2,
      date: "19.05.2025",
    },
    {
      username: "✅Verified Purchase",
      image: review3,
      date: "19.05.2025",
    },
    {
      username: "✅Verified Purchase",
      image: review4,
      date: "16.05.2025",
    },
    {
      username: "✅Verified Purchase",
      image: review5,
      date: "03.05.2025",
    },
  ];

  const scrollContainerRef = useRef(null);
  const offset = 300; // 280px Box + 20px Gap

  // Beim Klick auf den rechten Pfeil: scrollt nach rechts (scrollLeft erhöhen)
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = scrollContainerRef.current;
      let newScrollLeft = scrollLeft + offset;
      if (newScrollLeft > scrollWidth - clientWidth) {
        newScrollLeft = 0;
      }
      scrollContainerRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    }
  };

  // Beim Klick auf den linken Pfeil: scrollt nach links (scrollLeft verringern)
  const scrollLeftFunc = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = scrollContainerRef.current;
      let newScrollLeft = scrollLeft - offset;
      if (newScrollLeft < 0) {
        newScrollLeft = scrollWidth - clientWidth;
      }
      scrollContainerRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    }
  };

  return (
    // Füge hier die ID "reviews" hinzu, damit der Link in der Navbar den Container anspringt.
    <div className="reviews-component" id="reviews">
      <div className="reviews-inner">
        <h2>Reviews</h2>
        <p className="reviews-subtitle">
          What other Users are saying about our Rust Script
        </p>
        <div className="reviews-slider-container">
          <button className="slider-arrow left" onClick={scrollLeftFunc}>
            <FaChevronLeft />
          </button>
          <div className="reviews-boxes" ref={scrollContainerRef}>
            {reviewsData.map((review, index) => (
              <div key={index} className="review-box">
                <div className="review-stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="star-icon" />
                  ))}
                </div>
                <img className="review-image" src={review.image} alt={`Review ${index + 1}`} />
                <div className="review-footer">
                  <span className="review-username">{review.username}</span>
                  <span className="review-date">| {review.date}</span>
                </div>
              </div>
            ))}
          </div>
          <button className="slider-arrow right" onClick={scrollRight}>
            <FaChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
